import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import s from './styles';

function InfoModal({
  width = 428,
  height = 234,
  titleAlert,
  info1,
  info2,
  onclick,
  ...props
}) {
  const { t } = useTranslation();
  return (
    <Modal
      {...props}
      transitionName=""
      width={width}
      height={height}
      centered
      footer={null}
      bodyStyle={{ padding: 0, overflow: 'auto' }}
      closable={false}
      maskStyle={{ backdropFilter: 'blur(10px)' }}
      visible
    >
      <s.Wrapper>
        <s.Title>{titleAlert}</s.Title>
      </s.Wrapper>

      <s.WrapperContents>
        {!!info1 && <s.info>{info1}</s.info>}
        {!!info2 && <s.info>{info2}</s.info>}
      </s.WrapperContents>

      <s.Line />

      <s.WrapperButtons>
        <s.Button onClick={onclick}>{t('actions.accept')}</s.Button>
      </s.WrapperButtons>
    </Modal>
  );
}

export default InfoModal;
